import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { map, window } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserProfile } from '../_models/user-profile';
import { ConfigurationService } from './configuration.service';
//import { UserService } from "./user.service";

export interface LoginInfo {
  username: string;
  password: string;
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  })
};

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  userProfile: UserProfile;
  redirectUrl: string;
  private apiUrl: string = '';

  constructor(private http: HttpClient, private router: Router, private configurationService: ConfigurationService) {
    this.apiUrl = this.configurationService.config.apiAddress;
    this.configurationService.configData$.subscribe(res => this.apiUrl = res.apiAddress);
  }

  login(loginInfo: LoginInfo) {
    return this.http.post(this.apiUrl + 'api/Tokens/multicompany', loginInfo, httpOptions)
      .pipe(map(
        result => {
          return result;
        }
      ))
  }

  logout(expiredToken?: boolean) {
    localStorage.clear();
    if (expiredToken) {
      this.router.navigate(['login'], { queryParams: { expiredSession: 'true' } });
    }
    else {
      this.router.navigate(['login'], { queryParams: { logoutSuccess: 'true' } });
    }
  }

  webAppVersionOneStorageFound(): boolean {
    if (typeof window != 'undefined') {
      let username = localStorage.getItem("username") || null;
      if (username != null) {
        console.warn('WebAppVersionOneStorageFound');
        return true
      }
    }
    return false;
  }

  isAuthenticatedWithSelectedCompany(): boolean {
    // Returns boolean to indicate if user is logged in with unexpired token and has selected a company
    if (typeof window != 'undefined') {
      this.userProfile = JSON.parse(localStorage.getItem("userProfile")) || '';

      if (this.userProfile && this.userProfile.token && this.userProfile.currentCompany) {
        let expiration = this.userProfile.exp;
        if (expiration > (Date.now() / 1000)) {
          return true;
        }
        else {
          console.warn('Session has expired. Remove UserProfile');
          this.logout(true);
        }
      }
    }

    return false;
  }

  isAuthenticated(): boolean {
    // Returns boolean to indicate if user is logged in with unexpired token
    if (typeof window != 'undefined') {
      this.userProfile = JSON.parse(localStorage.getItem("userProfile")) || '';

      if (this.userProfile && this.userProfile.token) {
        let expiration = this.userProfile.exp;
        if (expiration > (Date.now() / 1000)) {
          return true;
        }
        else {
          console.warn('Session has expired. Remove UserProfile');
          this.logout(true);
        }
      }
    }

    return false;
  }

  getUserCompanies(username: string) {
    let bearerHttpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      })
    };

    return this.http.get(this.apiUrl + 'api/Users/' + username + '/Companies?hasPortalAccess=true', bearerHttpOptions);
  }

  getCompanyAccessAndPermissionsForUser() {
    return this.http.get(`${this.apiUrl}api/Users/Companies/Permissions`, httpOptions);
  }

}
